module.exports = __webpack_public_path__ + "assets/img/defuletNews.eb404baa.jpg";